import styled from "styled-components";
import { black, gray, white } from "../styles/colors";
import { ScrollReveal } from "./ScrollReveal";

const STEPS = [
  {
    number: "01",
    title: "Start a journey",
    description:
      "Name what you're working toward — guitar, marathon training, a startup, anything. Add chapters to mark the phases along the way.",
  },
  {
    number: "02",
    title: "Record a step each day",
    description:
      "Film a quick clip from your phone. Trim it, add a note, and log your progress. Reminders help you stay on track.",
  },
  {
    number: "03",
    title: "Watch yourself grow",
    description:
      "Scroll back through your timeline, build montages from your best clips, and share milestones with friends.",
  },
];

export function HowItWorks() {
  return (
    <Section id="how-it-works">
      <Header>
        <ScrollReveal>
          <Eyebrow>How it works</Eyebrow>
          <Title>Three steps. One story at a time.</Title>
        </ScrollReveal>
      </Header>
      <Steps>
        {STEPS.map((step, index) => (
          <ScrollReveal key={step.number} delay={index as 0 | 1 | 2}>
            <Step>
              <Number>{step.number}</Number>
              <StepTitle>{step.title}</StepTitle>
              <StepText>{step.description}</StepText>
            </Step>
          </ScrollReveal>
        ))}
      </Steps>
    </Section>
  );
}

const Section = styled.section({
  padding: "96px 24px",
  background: black,
  color: white,
});

const Header = styled.div({
  maxWidth: 680,
  margin: "0 auto 56px",
  textAlign: "center",
});

const Eyebrow = styled.p({
  margin: "0 0 12px",
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: gray,
});

const Title = styled.h2({
  margin: 0,
  fontSize: "clamp(32px, 4vw, 44px)",
  fontWeight: 700,
  letterSpacing: "-0.03em",
});

const Steps = styled.div({
  maxWidth: 1000,
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 32,

  "@media (max-width: 768px)": {
    gridTemplateColumns: "1fr",
    gap: 40,
  },
});

const Step = styled.div({
  padding: "0 8px",
});

const Number = styled.div({
  marginBottom: 20,
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: "0.14em",
  color: gray,
});

const StepTitle = styled.h3({
  margin: "0 0 12px",
  fontSize: 24,
  fontWeight: 700,
  letterSpacing: "-0.02em",
});

const StepText = styled.p({
  margin: 0,
  fontSize: 16,
  lineHeight: 1.75,
  color: "rgba(253, 253, 253, 0.68)",
});
